import { Theme } from "@remo-co/ui-core/src/types";
import { makeStyles } from "@remo-co/ui-core/src/utils/makeStyles";

const useStyles = makeStyles<Theme>((theme) => ({
  enterIcon: {
    borderRadius: "50%",
    color: theme.palette.white,
    background: theme.palette.secondary.main,
  },
  menuItem: {
    color: theme.palette.text.primary,
    padding: "8px 15px !important",
  },
}));

export default useStyles;
